import { Box, Container, Typography } from "@mui/material";
import { motion } from "motion/react";
import Section1 from "./Section1";
import MisionVisionValores from "./MisionVisionValores";
import Servicios from "./Servicios";
import QuienesSomos from "./QuienesSomos";
import Presentes from "./Presentes";
import Contacto from "./Contacto";
import Simuladores from "./Simuladores";
import Navbar from "./Navbar";


const Home = () => {

    return (
        <>
            <Navbar />
            <div id="inicio" style={{ paddingTop: "70px", }}>
                <Section1 />
            </div>
            <div id="quienes-somos">
                <QuienesSomos />
            </div>
            <div id="mision">
                <MisionVisionValores />
            </div>
            <div id="servicios">
                <Servicios />
            </div>
            <div id="simuladores">
                <Simuladores />
            </div>
            <div id="presentes">
                <Presentes />
            </div>
            <div id="contacto">
                <Contacto />
            </div>
           
        </>
    );
};

export default Home;